"use client";

import { ArrowRight } from "iconoir-react";

import { CustomerStorySidebarNav } from "@/components/customer-story";
import type { StoryNavItem } from "@/components/customer-story";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface ResearchSidebarProps {
  navItems: StoryNavItem[];
  download: {
    title: string;
    meta: string;
    buttonLabel: string;
  };
  emailPlaceholder: string;
  className?: string;
}

// Research report sticky sidebar (Figma 6860:34073).
export function ResearchSidebar({
  navItems,
  download,
  emailPlaceholder,
  className,
}: ResearchSidebarProps) {
  return (
    <aside
      className={cn(
        "border-grey-100 bg-grey-0 hidden w-[197px] shrink-0 border lg:block",
        className
      )}
    >
      <div className="bg-grey-0 sticky top-[calc(var(--nav-offset)+16px)] flex flex-col self-start">
        <CustomerStorySidebarNav items={navItems} />
        <div className="flex flex-col gap-2 p-3">
          <p className="text-grey-950 text-[16px] leading-[1.5] tracking-[-0.02em]">
            {download.title}
          </p>
          <p className="text-grey-500 text-[12px] leading-[1.4] tracking-[-0.02em]">
            {download.meta}
          </p>
          <SidebarDownloadButton
            label={download.buttonLabel}
            emailPlaceholder={emailPlaceholder}
          />
        </div>
      </div>
    </aside>
  );
}

function SidebarDownloadButton({
  label,
  emailPlaceholder,
}: {
  label: string;
  emailPlaceholder: string;
}) {
  return (
    <Button
      type="button"
      size="sm"
      className="bg-pulse-700 hover:bg-pulse-600 h-8 w-fit gap-2 rounded-full pr-3 pl-1.5"
      onClick={() => {
        const heroEmail = document.getElementById(
          "research-email"
        ) as HTMLInputElement | null;
        heroEmail?.focus();
        heroEmail?.scrollIntoView({ behavior: "smooth", block: "center" });
        if (!heroEmail?.value) {
          heroEmail?.setAttribute("placeholder", emailPlaceholder);
        }
      }}
    >
      <span className="grid size-5 place-items-center rounded-full bg-white/20">
        <ArrowRight
          className="size-3.5 rotate-90 text-white"
          strokeWidth={1.5}
        />
      </span>
      <span className="text-[12px] font-medium">{label}</span>
    </Button>
  );
}
